import { sessionDetails } from '../../../models/GSessions';
import {EventFullInfo} from '../../../models/event';
import React from 'react';
import * as validationStrings from './GSessionEditModalConstants';
import DateTimePicker from 'react-datetime-picker';

interface GSessionCreateModalProps {
    requestClose: () => void,
    event: EventFullInfo,
    user_name: string,
    onSessionCreate: (sesh: sessionDetails) => Promise<boolean>
}

const GSessionCreateModal = (props: GSessionCreateModalProps) => {

    const [startTime, setStartTime] = React.useState<Date>(props.event.start_DateTime.toDate());
    const [stopTime, setStopTime] = React.useState<Date>(props.event.end_DateTime.toDate());
    const [sessionName, setSessionName] = React.useState<string>("");
    const [bggPage, setBggPage] = React.useState<string>("");
    const [sessionDesc, setSessionDesc] = React.useState<string>("");
    const [tableNum, setTableNum] = React.useState<string>("");
    const [slotMax, setSlotMax] = React.useState<string>("");
    const [autoRSVP, setAutoRSVP] = React.useState<boolean>(false);
    const [statusMsg, setStatusMsg] = React.useState<string>("");
    const [falureMessage, setFailureMessage] = React.useState<boolean>(false);

    React.useEffect(() => {
        const startTimeInPast = startTime < new Date();
        const startOutOfBounds = startTime < props.event.start_DateTime || startTime > props.event.end_DateTime
        const endTimeInPast = stopTime < new Date();
        const endOutOfBounds = stopTime < props.event.start_DateTime || stopTime > props.event.end_DateTime
        const endBeforeBegin = startTime > stopTime;
        const nameIsNull = sessionName.trim() === "";
        const tableOutOfBounds = parseInt(tableNum,10) < props.event.lowest_Table_Number || parseInt(tableNum,10) > props.event.highest_Table_Number
        const slotsIsBad = slotMax.trim() === "0" || slotMax.trim() === "";
        const tooManySlots = +slotMax > props.event.slots;

        const message = [
            (startTimeInPast ? validationStrings.START_TIME_IN_PAST : []),
            (startOutOfBounds ? validationStrings.START_OUT_OF_BOUNDS : []),
            (endTimeInPast ? validationStrings.END_TIME_IN_PAST : []),
            (endOutOfBounds ? validationStrings.END_OUT_OF_BOUNDS : []),
            (endBeforeBegin ? validationStrings.END_BEFORE_BEGIN : []),
            (nameIsNull ? validationStrings.NAME_IS_NULL : []),
            (tableOutOfBounds ? validationStrings.TABLE_OUT_OF_BOUNDS : []),
            (slotsIsBad ? validationStrings.SLOTS_IS_BAD : []),
            (tooManySlots ? validationStrings.TOO_MANY_SLOTS : [])
        ].join('\n');

        const trimmedMessage = message.trim()

        setStatusMsg(trimmedMessage.length === 0 ? "" : message);


    },[startTime, stopTime, sessionName, tableNum, slotMax]);

    const requestCreate = () => {

        setFailureMessage(false);

        const outputSesh : sessionDetails = {
            start: startTime,
            end: stopTime,
            name: sessionName,
            bgg_title_link: bggPage,
            info: sessionDesc,
            room: "",
            table: tableNum,
            slots: parseInt(slotMax),
            owner_player: autoRSVP,
            owner: props.user_name,
            id: 0,
            evt: props.event.id
        }

        props.onSessionCreate(outputSesh).then((res) => {
            if (res === false)
            {
                setFailureMessage(true);
            }
        })
    }

    console.log(startTime);
    console.log(stopTime);

    return (
    <div>
        <h3>Create Session</h3>
        <hr />
        <div className="modalContent">
            <p>Session Name</p>
            <input name="SessionName"
                className="largeInput"
                placeholder="Game Name"
                value={sessionName}
                onChange={(val) => setSessionName(val.target.value)} />
            <p>BGG Page</p>
            <textarea name="BGGPage"
                className="largeTextField"
                value={bggPage}
                placeholder="https://www.boardgamegeek.com/....."
                onChange={(e) => setBggPage(e.target.value)} />
            <p>Description</p>
            <textarea name="Description"
                className="largeTextField"
                placeholder="What people need to know"
                value={sessionDesc}
                onChange={(e) => setSessionDesc(e.target.value)} />
            <p>Table</p>
            <input name="Table"
                className="smallInput"
                value={tableNum}
                onChange={(e) =>{setTableNum(e.target.value)}} />
            <p>Number of Slots</p>
            <input type="number"
                    min="2"
                    max={props.event.slots}
                    name="Slots"
                    className="smallInput"
                    placeholder="Maximum number of participants"
                    value={slotMax}
                    onChange={(e) => setSlotMax(e.target.value)} />
            <p>Start Time</p>
            <DateTimePicker name="StartTime"
                value={startTime as Date}
                onChange={(val) => setStartTime(val as Date)} />
            <p>Stop Time</p>
            <DateTimePicker name="StopTime"
                value={stopTime as Date}
                onChange={(val) => setStopTime(val as Date)} />
            <br></br>
            <br></br>
            <label>
                <input type="checkbox" name="AutoRSVP"
                    checked={autoRSVP}
                    onChange={() => setAutoRSVP(!autoRSVP)} /> Also sign yourself up for this session
            </label>
            <br></br>
            <br></br>
        </div>
        <div className="modalButtons">
            <div className="defaultMode"> 
                {statusMsg === "" ? <button className="buttonPrimary" onClick={() => requestCreate()}>Create Session</button> : <p>{statusMsg}</p>}
                <button className="buttonPrimary" onClick={() => props.requestClose()}>Back to Calendar</button>
            </div>
        </div>
    </div>)
}

export default GSessionCreateModal;